import React, { useState, useEffect } from 'react'
import { CompanyLogo } from 'assets'

import { Box } from '@mui/material'

const sx = {
  img: {
    borderRadius: '10px',
  },
  img2: {
    width: 236,
    height: 100,
    borderRadius: '10px',
    background: '#F2F8FC',
  },
}

const BusinessAvatarHome = ({ model, width, height }) => {
  const [imageLoaded, setImgLoaded] = useState(true)

  useEffect(() => {
    if (model !== null) {
      setImgLoaded(!!model.bus_photo !== null || !!model.web.length || !!model.details.photoFileId.length)
    }
  }, [model, model?.bus_photo, model?.details.photoFileId, model?.web])

  if (model?.details.photoFileId && imageLoaded) {
    return (
      <Box width="160px" height="110px" display="flex" alignItems="center" justifyContent="center">
        <Box
          component={'img'}
          style={{ maxWidth: '180px', maxHeight: '130px' }}
          sx={sx.img}
          src={`${process.env['REACT_APP_BACKEND_BASE_AUTH_URL']}/static/images/business/${model.details.photoFileId}`}
          alt="business logo"
        />
      </Box>
    )
  }

  if (model?.web && imageLoaded) {
    return (
      <Box width="140px" height="110px" display="flex" alignItems="center" justifyContent="center">
        <Box
          component={'img'}
          style={{ maxWidth: '130px', maxHeight: '130px' }}
          sx={sx.img}
          onError={() => setImgLoaded(false)}
          src={`//logo.clearbit.com/${model.details.website || model.web}`}
          alt="business logo"
        />
      </Box>
    )
  }

  if (!imageLoaded) {
    return (
      <div>
        {/* <Box
          component={'img'}
          sx={sx.img2}
          onError={() => setImgLoaded(false)}
          src={BusinessLogo}
          alt="businessdummylogo"
        /> */}
        <CompanyLogo />
      </div>
    )
  }

  return <div></div>
}
export default BusinessAvatarHome
